import React from 'react'
import { InstallationOnlineStatusContextProps } from '../types'

export const InstallationOnlineStatusContext = React.createContext<InstallationOnlineStatusContextProps>({
  isStorageOnline: true,
  isLoading: true,
})
